<ng-container *ngIf="employee$ | async as employee; else loadingTemplate">
  <div *ngIf="checkPermission('employeePosition') && (availableWidgets$ | async)?.employee?.['positions-files']?.position" class="row">
    <div class="col-12">
      <app-employee-positions
          (refetchEntityRequests)="getActiveRequests(this.employeeID)"
          (refetchPositions)="getPositions()"
          *ngIf="employeePositions$"
          [employee]="employee"
          [entityRequests]="entityRequests"
          [positions$]="employeePositions$"
      ></app-employee-positions>
    </div>
  </div>
  
  <app-employee-salaries-payrolls (refetchEntityRequests)="getActiveRequests(this.employeeID)"
                                  [employee]="employee"
                                  [entityRequests]="entityRequests"></app-employee-salaries-payrolls>
  
  <div *ngIf="(availableWidgets$ | async)?.employee?.['positions-files']?.structure" class="row">
    <div class="col-12">
      <div class="card shadow">
        <app-help name="employee.detail.structure"></app-help>
        
        <div class="card-header card-header--padding">
          <p class="modal-title font-16 text-dark pt-2 pb-2">
            <span>{{ 'company_groups.structure_tree' | translate }}</span>
          </p>
        </div>
        
        <div class="card-body px-4">
          <div *ngIf="noCompanyGroup" class="row mb-2">
            <div class="col-12">
              <span> {{ 'company_groups.no_company_group_text' | translate }} </span>
              <u (click)="openEmployeeChangeCompanyGroupModal()"> {{ 'employees.change_company_group' | translate }} </u>
            </div>
          </div>
          <app-employee-structure-tree *ngIf="!companyGroupChanging"
                                       [employeeId]="employeeID"
                                       [hideEmployeeFromStucture]="employee?.is_hidden_in_structure"
                                       [justChart]="true"
          ></app-employee-structure-tree>
        </div>
      </div>
    </div>
  </div>
</ng-container>


<ng-template #loadingTemplate>
  <div class="row">
    <div class="col-12">
      <div class="card shadow p-3">
        <ngx-skeleton-loader [theme]="{ width: '100%', 'margin': '25px 0', 'display': 'block' }"
                             appearance="line"
                             count="6">
        </ngx-skeleton-loader>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card shadow p-3">
        <ngx-skeleton-loader [theme]="{ width: '100%', 'margin': '25px 0', 'display': 'block' }"
                             appearance="line"
                             count="6">
        </ngx-skeleton-loader>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card shadow p-3">
        <ngx-skeleton-loader [theme]="{ width: '100%', 'margin': '25px 0', 'display': 'block' }"
                             appearance="line"
                             count="6">
        </ngx-skeleton-loader>
      </div>
    </div>
  </div>
</ng-template>
